import React from "react";
import { useEffect } from "react";
import Banners from "./Banners";
import Detailedsearch from "../Pages/Detailedsearch";

export const IndexBanner = () => {
  useEffect(() => {
    var i = 0;
    // Placeholder Animation Start
    var inputSelector = document.querySelectorAll("input, textarea");
    for (i = 0; i < inputSelector.length; i++) {
      inputSelector[i].addEventListener("focus", function (event) {
        return this.parentElement.parentElement.classList.add("focused");
      });
    }
    for (i = 0; i < inputSelector.length; i++) {
      inputSelector[i].addEventListener("blur", function (event) {
        var inputValue = this.value;
        if (inputValue === "") {
          this.parentElement.parentElement.classList.remove("filled");
          this.parentElement.parentElement.classList.remove("focused");
        } else {
          this.parentElement.parentElement.classList.add("filled");
        }
      });
    }
    // Placeholder Animation End
  });
  const banner = require("../../images/banner.jpg");
  return (
    <>
      <div
        className="dez-bnr-inr dez-bnr-inr-md d-block w-100"
        style={{
          backgroundSize: `100% 100%`,
          backgroundImage: `url(${banner})`,
          backgroundRepeat: "no-repeat",
          // filter: "brightness(80%)",
        }}
      >
        {/* <div>
          <img
            className="d-block w-100"
            src={banner}
            style={{ height: "89vh" }}
            alt="First slide"
          />
        </div> */}

        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-12 col-lg-8 col-xl-8 col-12">
            <section class="search-sec">
              <div className="container">
                <div className="dez-bnr-inr-entry align-m">
                  <div className="find-job-bx">
                    <Detailedsearch />
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>
      <Banners />
    </>
  );
};

export default IndexBanner;
